import React from 'react';
import { motion } from 'framer-motion';
export function StatsBar() {
  const stats = [{
    value: '40–60%',
    label: 'Cost Savings'
  }, {
    value: '5–10',
    label: 'Days to Shortlist'
  }, {
    value: '2–3',
    label: 'Weeks to Hire'
  }, {
    value: '90-Day',
    label: 'Guarantee'
  }];
  return <section className="border-y border-slate-100 bg-white relative z-20" data-id="element-245">
      <div className="max-w-7xl mx-auto px-6" data-id="element-246">
        <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-slate-100" data-id="element-247">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="py-10 px-4 text-center flex flex-col items-center justify-center" data-id="element-248">
              <div className="text-3xl md:text-4xl font-display font-bold text-navy mb-2" data-id="element-249">
                {stat.value}
              </div>
              <div className="text-sm font-medium text-slate-500 uppercase tracking-wider" data-id="element-250">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}